var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      !_vm.initialLoading && !_vm.hasPhotos
        ? _c(
            "v-alert",
            {
              staticClass: "ma-0",
              staticStyle: { background: "white" },
              attrs: { outline: "", type: "warning" },
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("StationDetailPhotos.noPhotos")) +
                    "\n    "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.initialLoading
        ? _c("v-progress-linear", {
            attrs: { indeterminate: "", color: "info" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-actions",
            { staticClass: "card-bg-2 py-2 layout wrap" },
            [
              _c(
                "v-chip",
                {
                  staticClass: "my-0 ml-0 title",
                  attrs: { label: "", color: "primary", "text-color": "white" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        `${
                          _vm.filteredPhotos.length > 0 ? _vm.photoIndex + 1 : 0
                        } / ${_vm.filteredPhotos.length}`
                      ) +
                      "\n        "
                  ),
                  _vm.totalCount
                    ? _c("span", { staticClass: "ml-1 caption" }, [
                        _vm._v("(of " + _vm._s(_vm.totalCount) + " total)"),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { large: "", icon: "", disabled: _vm.loading.image },
                  on: {
                    click: function ($event) {
                      return _vm.previous()
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { large: "" } }, [
                    _vm._v("mdi-chevron-left"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { large: "", icon: "", disabled: _vm.loading.image },
                  on: {
                    click: function ($event) {
                      return _vm.next()
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { large: "" } }, [
                    _vm._v("mdi-chevron-right"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-2",
                  attrs: {
                    color: "info",
                    disabled: !_vm.currentPhoto.Url || _vm.loading.image,
                    href: _vm.currentPhoto.Url,
                    target: "_blank",
                  },
                },
                [
                  _c("v-icon", [_vm._v("save_alt")]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("Button.Download")) +
                      "\n      "
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { lg8: "", md12: "", xs12: "" } },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: { type: "error", outline: "" },
                      model: {
                        value: _vm.getImgFailed,
                        callback: function ($$v) {
                          _vm.getImgFailed = $$v
                        },
                        expression: "getImgFailed",
                      },
                    },
                    [_vm._v("Failed to get photo.")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticClass: "image-container",
                      attrs: { "align-center": "", "justify-center": "" },
                    },
                    [
                      _vm.initialLoading
                        ? _c("v-progress-circular", {
                            attrs: {
                              size: "64",
                              indeterminate: "",
                              color: "white",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.initialLoading && _vm.currentPhoto.Url
                        ? _c("img", {
                            key: _vm.currentPhoto.Url,
                            staticClass: "img-photo",
                            attrs: { src: _vm.currentPhoto.Url },
                            on: { load: _vm.onload, error: _vm.onerror },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.initialLoading &&
                      _vm.loading.image &&
                      _vm.currentPhoto.Url
                        ? _c("v-progress-circular", {
                            staticClass: "image-progress",
                            attrs: {
                              large: "",
                              indeterminate: "",
                              color: "white",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "image-info-bar pa-3 body-2" }, [
                    _c("div", { staticClass: "mb-1" }, [
                      _vm._v(_vm._s(_vm.currentPhoto.Name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "grey--text text--darken-1" }, [
                      _vm._v(_vm._s(_vm.currentPhoto.UploadedAt)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "headline pt-2 pb-1" },
                        [
                          _vm._v("\n            Photo Details\n            "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _vm.isSystemAdmin &&
                          _vm.adminPhotoDetail &&
                          !_vm.showAdminDetail
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { small: "", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showAdminDetail = true
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("edit"),
                                  ]),
                                  _vm._v(" Edit\n            "),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _vm.isSystemAdmin &&
                          !_vm.adminPhotoDetail &&
                          !_vm.adminFetchError
                            ? _c("v-progress-linear", {
                                staticClass: "mb-2",
                                attrs: { indeterminate: "", color: "info" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSystemAdmin && _vm.adminFetchError
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "mb-2",
                                  attrs: { type: "error", outline: "" },
                                },
                                [_vm._v(_vm._s(_vm.adminFetchError))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSystemAdmin && _vm.adminPhotoDetail
                            ? [
                                _c("v-text-field", {
                                  attrs: {
                                    label: "Name",
                                    value: _vm.adminPhotoDetail.Name,
                                    disabled: "",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: {
                                    label: "Created",
                                    value: _vm.formatDate(
                                      _vm.adminPhotoDetail.CreatedAt,
                                      _vm.formats.prettyDateFormat
                                    ),
                                    disabled: "",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: {
                                    label: "File Size",
                                    value: _vm.formatBytes(
                                      _vm.adminPhotoDetail.FileSizeBytes
                                    ),
                                    disabled: "",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: {
                                    label: "Blob URL",
                                    value: _vm.adminPhotoDetail.BlobUrl,
                                    disabled: "",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.showAdminDetail
                                  ? _c("v-textarea", {
                                      attrs: {
                                        label: "Notes",
                                        counter: 2000,
                                        maxlength: 2000,
                                        disabled: _vm.adminSaving,
                                        rows: "3",
                                      },
                                      model: {
                                        value: _vm.adminNotes,
                                        callback: function ($$v) {
                                          _vm.adminNotes = $$v
                                        },
                                        expression: "adminNotes",
                                      },
                                    })
                                  : _c("v-text-field", {
                                      attrs: {
                                        label: "Notes",
                                        value: _vm.adminPhotoDetail.Notes,
                                        disabled: "",
                                      },
                                    }),
                                _vm._v(" "),
                                _vm.showAdminDetail
                                  ? _c(
                                      "div",
                                      { staticClass: "text-xs-right mt-2" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "ml-0",
                                            attrs: {
                                              color: "error",
                                              outline: "",
                                              disabled:
                                                _vm.adminDeleting ||
                                                _vm.adminSaving,
                                            },
                                            on: { click: _vm.confirmDelete },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Delete Photo\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "secondary",
                                              disabled:
                                                _vm.adminSaving ||
                                                _vm.adminDeleting,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.showAdminDetail = false
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Cancel\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              disabled:
                                                _vm.adminSaving ||
                                                !_vm.adminPhotoDetail,
                                              loading: _vm.adminSaving,
                                            },
                                            on: { click: _vm.saveNotes },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Save\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isSystemAdmin
                            ? [
                                _c("div", { staticClass: "mb-2" }, [
                                  _c("div", { staticClass: "body-2" }, [
                                    _vm._v("Name"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "word-break": "break-all",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.currentPhoto.Name))]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("div", { staticClass: "body-2" }, [
                                    _vm._v("Uploaded on"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.currentPhoto.UploadedAt)),
                                  ]),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticClass: "divider-left",
                  attrs: { lg4: "", md12: "", xs12: "" },
                },
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Filters"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "pt-2" },
                    [
                      _c("DateRange", {
                        attrs: {
                          startToEndOfDay: "",
                          box: "",
                          "min-max-placeholder": _vm.formats.prettyDateFormat,
                          shortcutPrefix: "Show",
                          shortcuts: _vm.shortcuts,
                          dataType: "photos",
                          "no-arrows": "",
                        },
                        model: {
                          value: _vm.dates,
                          callback: function ($$v) {
                            _vm.dates = $$v
                          },
                          expression: "dates",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Photo List"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "pt-0" },
                    [
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.photoItems,
                          "hide-actions": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function (props) {
                              return [
                                _c(
                                  "tr",
                                  {
                                    staticStyle: { cursor: "pointer" },
                                    style:
                                      props.index === _vm.photoIndex
                                        ? {
                                            background:
                                              "rgba(33, 150, 243, 0.15)",
                                          }
                                        : {},
                                    on: {
                                      click: function ($event) {
                                        return _vm.goToPhoto(props.item)
                                      },
                                    },
                                  },
                                  [
                                    _c("td", [_vm._v(_vm._s(props.index + 1))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(props.item.Name))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(props.item.UploadedAt)),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _vm.hasMore
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                block: "",
                                outline: "",
                                color: "info",
                                loading: _vm.loadingMore,
                              },
                              on: { click: _vm.loadMore },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.loadingMore ? "Loading..." : "Load More"
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400px" },
          model: {
            value: _vm.deleteConfirmDialog,
            callback: function ($$v) {
              _vm.deleteConfirmDialog = $$v
            },
            expression: "deleteConfirmDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Delete Photo"),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        Are you sure you want to permanently delete this photo? This action cannot be undone.\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "secondary",
                        disabled: _vm.adminDeleting,
                      },
                      on: {
                        click: function ($event) {
                          _vm.deleteConfirmDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", loading: _vm.adminDeleting },
                      on: { click: _vm.executeDelete },
                    },
                    [_vm._v("Delete")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }